import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgencyLayoutComponent } from './agency-layout/agency-layout.component';
import { LayoutSidebarComponent } from './agency-layout/layout-sidebar/layout-sidebar.component';
import { LayoutHeaderComponent } from './agency-layout/layout-header/layout-header.component';
import { AgencyRoutingModule } from './agency-routing.module';
import { AgencyDashboardComponent } from './agency-dashboard/agency-dashboard.component';
import { AgencyRegistrationComponent } from './agency-registration/agency-registration.component';
import { AgenciesComponent } from './agencies/agencies.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbCollapseModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from '../material/material-module';
import { LightboxModule } from 'ngx-lightbox';
import { CoreModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { NgxMaskModule } from 'ngx-mask';
import { AddNewMemberComponent } from './add-new-member/add-new-member.component';
import { AgencyEmployeeComponent } from './agency-employee/agency-employee.component';

@NgModule({
  declarations: [
    AgencyLayoutComponent,
    LayoutSidebarComponent, LayoutHeaderComponent,
    AgencyDashboardComponent,
    AgencyRegistrationComponent,
    AgenciesComponent,
    AddNewMemberComponent,
    AgencyEmployeeComponent
  ],
  imports: [
    CommonModule,
    AgencyRoutingModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbModalModule,
    NgbCollapseModule,
    MaterialModule,
    LightboxModule,
    CoreModule,
    SharedModule,
    NgxMaskModule.forRoot(),
  ],
  entryComponents:[
    AddNewMemberComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AgencyModule { }
